import type { GetServerSideProps, NextPage } from 'next'
import { observer } from 'mobx-react'

import { Layout } from '~/layouts/default'
import { GlobalRequest } from '~/components/global-requset'
import { SEOHead } from '~/components/business/SEOHead'
import { ArticleHeader } from '~/components/pages/article/ArticleHeader'
import { HtmlContent } from '~/components/ui/HtmlContent'
import { serverSideCatch } from '~/utils'

import {
  getArticleDetail,
  getArticleDetailVariables,
  getArticleDetail_articleGraph_detail,
  PostStatus,
} from '~/graphqls/types'
import { GET_ARTICLE_DETAIL } from '~/graphqls/gqls'

const ArticleDetail: NextPage<{
  article: getArticleDetail_articleGraph_detail
}> = ({ article }) => {
  return (
    <Layout>
      <div className=" w-[800px] m-auto px-6">
        <SEOHead title={article?.post?.title} />
        {article && <ArticleHeader article={article} />}
        <HtmlContent
          data={article?.post?.content || ''}
          className="ne-article-html mt-4"
        />
      </div>
    </Layout>
  )
}

export const getServerSideProps: GetServerSideProps = async context => {
  return await serverSideCatch(async () => {
    const { initialState, client } = await GlobalRequest(context)
    const articleId = Number(context.params?.id)
    const articleRes = await client.query<
      getArticleDetail,
      getArticleDetailVariables
    >({
      query: GET_ARTICLE_DETAIL,
      variables: {
        postId: articleId,
      },
      fetchPolicy: 'no-cache',
    })

    if (
      articleRes?.data?.articleGraph?.detail?.post?.postStatus !==
      PostStatus.PUBLISH
    ) {
      return {
        notFound: true,
      }
    }

    return {
      props: {
        initialState,
        article: articleRes?.data?.articleGraph?.detail,
      },
    }
  })
}

export default observer(ArticleDetail)
